export default function SectionHeader({ overline, title, subtitle, right, size = "lg" }) {
  const titleCls = {
    md: "text-xl sm:text-2xl lg:text-3xl",
    lg: "text-2xl sm:text-4xl lg:text-5xl",
  }[size];
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-6">
      <div className="min-w-0">
        {overline && (
          <div className="text-[10px] text-amber-500 font-mono uppercase tracking-[0.25em] mb-2">
            {overline}
          </div>
        )}
        <h1 className={`font-display font-black tracking-tight text-zinc-50 ${titleCls}`}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-zinc-500 mt-2 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {right}
    </div>
  );
}
